module.exports = __webpack_public_path__ + "img/Imagen2.65236700.webp";